<template>
  <div>
    <Breadcrumbs :breadcrumbs="[
    {title: this.$t(`menu.${this.serviceSlug}`)},
    {title: this.$t(`menu.people-manager/list`), disabled: true}
  ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2"
                    :querySearch.sync="querySearch" />

        <!--<Filters
          class="mr-2"
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />-->
      </div>
    </Breadcrumbs>

    <PeopleManagerTable
      ref="peopleManagerTable"
      :querySearch="querySearch"
      :showFilters="showFilters"
      :serviceSlug="serviceSlug"
      @filters-updated="onFiltersUpdated"/>
  </div>
</template>

<script>
 import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
 import Searchable from '@/components/common/Searchable.vue';
 import Filters from '@/components/common/Filters.vue';
 import PeopleManagerTable from '@/components/people-manager/list/PeopleManagerTable.vue';
 import IndexTablesMixin from '@/mixins/IndexTablesMixin.vue';
 import { TABLE_PEOPLE_MANAGER_APPOINTMENTS } from '@/local-storage/LocalStorageKeys';

 export default {
   components: { PeopleManagerTable, Filters, Searchable, Breadcrumbs },
   props: {
     component: {
       type: Object,
       required: true
     },
     serviceSlug: {
       type: String,
       required: true
     }
   },
   mixins: [IndexTablesMixin],
   data: function () {
     return {
       localStorageKey: TABLE_PEOPLE_MANAGER_APPOINTMENTS,
       querySearch: '',
       showFilters: false,
       activeFilters: 0,
     }
   },
   methods: {
     onFiltersUpdated: function (activeFilters) {
       this.activeFilters = activeFilters
     },
     toggleFilters: function () {
       this.showFilters = !this.showFilters
     }
   },
   watch: {
     activeFilters: function (count) {
       this.showFilters = count > 0
     }
   }
 }
</script>
<style scoped lang="scss">

</style>
